import * as React from 'react';
import { FC, SVGProps } from 'react';

const Email: FC<SVGProps<SVGSVGElement>> = props => (
    <svg
        width={20}
        height={16}
        viewBox="0 0 20 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.6535 7.9999L18 3.02818V12.9718L12.6535 7.9999ZM17.5638 2.29852H2.43619C2.43441 2.29852 2.43269 2.29887 2.43097 2.29887L9.93437 9.27646C9.95213 9.29308 9.97554 9.30233 9.99986 9.30233C10.0242 9.30233 10.0476 9.29308 10.0653 9.27646L17.5691 2.29887C17.5672 2.29887 17.5657 2.29852 17.5638 2.29852ZM2 12.9718V3.02818L7.34653 7.9999L2 12.9718ZM2.43619 13.7014H17.5638C17.5655 13.7014 17.5672 13.7011 17.5691 13.7011L12.0458 8.56505L10.6291 9.8823C10.4579 10.0407 10.2332 10.1286 10 10.1286C9.76678 10.1286 9.54213 10.0407 9.37091 9.8823L7.95419 8.56505L2.43106 13.7009C2.43275 13.7009 2.43438 13.7013 2.43619 13.7013V13.7014Z"
            fill="black"
        />
    </svg>
);

export default Email;
